module.exports = __webpack_public_path__ + "media/ping_web.bc55cead.webm";